const tarDate = $('.hkr_Countown').attr('data-date').split('-');
  const day = parseInt(tarDate[0]);
  const month1 = parseInt(tarDate[1]);
  const year1 = parseInt(tarDate[2]);
  let tarTime = $('.hkr_Countown').attr('data-time');
  let tarhour, tarmin;

  if (tarTime != null) {
    tarTime = tarTime.split(':');
    tarhour = parseInt(tarTime[0]);
    tarmin = parseInt(tarTime[1]);
  }

  let months = [31, new Date().getFullYear() % 4 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let dateNow = new Date();
  let dayNow = dateNow.getDate();
  let monthNow = dateNow.getMonth() + 1;
  let yearNow = dateNow.getFullYear();
  let hourNow = dateNow.getHours();
  let minNow = dateNow.getMinutes();
  let secNow = dateNow.getSeconds();
  let count_day = 0, count_hour = 0, count_min = 0;
  let count_day_isSet = false;
  let isOver = false;

  // Set the date we're counting down to
  const countDownDate = new Date(year1, month1-1, day, tarhour, tarmin, 0, 0).getTime();

let days=document.getElementById('days');
let hours=document.getElementById('hours');
let minutes=document.getElementById('minutes');
let seconds=document.getElementById('seconds');

let ddd= document.getElementById('dd');
let hhh= document.getElementById('hh');
let mmm= document.getElementById('mm');
let sss= document.getElementById('ss');

let day_dot= document.getElementById('day_dot');
let hr_dot= document.getElementById('hr_dot');
let min_dot= document.getElementById('min_dot');
let sec_dot= document.getElementById('sec_dot');

let endDate='10/09/2024 24:00:00';
//date format mm/dd/yy
let x=setInterval(function(){
let now = new Date(endDate).getTime();
let countDown= new Date().getTime();
let distance = countDownDate - countDown;

//time calculation for day,hours and Mins
let d = Math.floor(distance / (1000 * 60 * 60 * 24));
let h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
let m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
let s = Math.floor((distance % (1000 * 60 )) / (1000));
  
//o/p the result in element with id

days.innerHTML = d;
hours.innerHTML = h;
minutes.innerHTML = m;
seconds.innerHTML = s;  

//animate stroke
ddd.style.strokeDashoffset= -250-(-250*d)/365;
hhh.style.strokeDashoffset= -250-(-250*h)/24;
mmm.style.strokeDashoffset= -250-(-250*m)/60;
sss.style.strokeDashoffset= -250-(-250*s)/60;

//animate circle dots // 360deg / d/h/m
day_dot.style.transform=`rotateZ(${d*(360/365)}deg)`;
hr_dot.style.transform=`rotateZ(${h*(360/24)}deg)`;
min_dot.style.transform=`rotateZ(${m*(360/60)}deg)`;
sec_dot.style.transform=`rotateZ(${s*(360/60)}deg)`;
  
if(distance < 0) {
  clearInterval(x);
  document.getElementById("time").style.visibility = "hidden";
}
  
})